export const getHeaderText =
  (inlineBlocks) =>
    inlineBlocks.reduce((acc, { text }, i) => i === 0 ? text : `${acc} ${text}`, '');
